import { adjustScheduleArrayForTimezone } from '../../../../common/recruitment';
import { getDefaultTimezoneUTCOffset, offsetToTimezone } from '../../../libs/utils';
import { getCommittedDays, getCommittedHours } from '../utils';
import { SchedulePreview } from './SchedulePreview';
import { t } from 'i18next';
import cx from 'classnames';
import { TBaseRecruitmentProfile } from '../../../../types/recruitmentTypes';
import { RecruitmentProfilePreviewCallout } from './RecruitmentProfilePreviewCallout';
import { RecruitmentEntityType } from '../../../../types/recruitmentTypes';
import _ from 'lodash';

const styles = {
  sectionHeading: 'character-recruitment-preview--sectionHeading',
  scheduleCalloutContainer: 'character-recruitment-preview--scheduleCalloutContainer'
};

type TRecruitmentProfileSchedulePreviewProps = {
  profile: TBaseRecruitmentProfile;
  useProfileTimezone?: boolean;
};

export function RecruitmentProfileSchedulePreview(props: TRecruitmentProfileSchedulePreviewProps) {
  const { profile } = props;
  const callouts = [];

  const committedDays = getCommittedDays(profile);
  const committedHours = getCommittedHours(profile);

  const utcOffset = props.useProfileTimezone
    ? offsetToTimezone(profile.schedule_timezone)
    : getDefaultTimezoneUTCOffset();

  const adjustedSchedule = adjustScheduleArrayForTimezone(profile.schedule, utcOffset);

  if (!_.isEmpty(adjustedSchedule)) {
    callouts.push(<SchedulePreview key="schedule" schedule={adjustedSchedule} />);
  }

  if (committedDays && committedDays.length > 0) {
    callouts.push(
      <RecruitmentProfilePreviewCallout
        key="days"
        className="slds-col"
        value={committedDays.join('-')}
        label={t('recruitment:tooltip.days_per_week')}
      />
    );
  }

  if (committedHours && committedHours.length > 0) {
    callouts.push(
      <RecruitmentProfilePreviewCallout
        key="hours"
        className="slds-col"
        value={committedHours.join('-')}
        label={t('recruitment:tooltip.hours_per_day')}
      />
    );
  }

  if (callouts.length === 0) {
    return null;
  }

  return (
    <div className={styles.scheduleCalloutContainer}>
      <div className={cx(styles.sectionHeading, 'slds-m-bottom--small')}>
        <span className="text-muted text-bold">
          {t(
            profile.entity_type === RecruitmentEntityType.Character
              ? 'recruitment:tooltip.availability'
              : 'recruitment:tooltip.schedule'
          )}
        </span>
      </div>
      <div className={'slds-grid slds-wrap slds-grid--align-center slds-grid--align-space'}>{callouts}</div>
    </div>
  );
}
